import Vue from 'vue'
import Overdrive from 'vue-overdrive'
import LottieAnimation from 'lottie-vuejs'
import Notifications from 'vue-notification'

const DatePicker = () => import('@/components/forms/DatePicker')
const SingleSelector = () => import('@/components/forms/SingleSelector')
const Checkbox = () => import('@/components/forms/Checkbox')
const TimePicker = () => import('@/components/forms/TimePicker')
const ActionButton = () => import('@/components/forms/ActionButton')
const TextButton = () => import('@/components/forms/TextButton')
const RightClickMenu = () => import('@/components/tools/RightClickMenu')
const AppLoading = () => import('@/components/tools/AppLoading')
const SelectorWrap = () => import('@/components/tools/SelectorWrap')
const ListLoader = () => import('@/components/tools/ListLoader')
const ListPlaceholder = () => import('@/components/tools/ListPlaceholder')
import linkify from 'vue-linkify'
export default () => {
    Vue.component('ListPlaceholder', ListPlaceholder)
    Vue.component('TextButton', TextButton)
    Vue.component('ActionButton', ActionButton)
    Vue.component('DatePicker', DatePicker)
    Vue.component('Checkbox', Checkbox)
    Vue.component('SingleSelector', SingleSelector)
    Vue.component('RightClickMenu', RightClickMenu)
    Vue.component('AppLoading', AppLoading)
    Vue.component('ListLoader', ListLoader)
    Vue.component('SelectorWrap', SelectorWrap)
    Vue.component('TimePicker', TimePicker)
    Vue.use(Notifications)
    Vue.use(Overdrive)
    Vue.use(LottieAnimation)

    Vue.directive('linkified', linkify)
}
